//idcard脱敏
export  const idCardChange = (value) =>{
    if(value){
        return value.replace(/(\w{6})\w*(\w{4})/, '$1********$2')
    }else{
        return '--'
    }  
}

//mobile脱敏
export const mobile = (value) =>{
    if(value){
        return value.replace(/(\w{3})\w*(\w{4})/,'$1****$2')
    }else{
        return '--'
    }
}

//时间
export const dateTime = (value,index) =>{
    if(value && value !== '0' && value != '86430'){
        var date = new Date(value*1000) //时间戳为10位需*1000，时间戳为13位的话不需乘1000
        var Y = date.getFullYear() + '-'
        var M = (date.getMonth()+1 < 10 ? '0'+(date.getMonth()+1) : date.getMonth()+1) + '-'
        var D = date.getDate() < 10 ? '0'+date.getDate() : date.getDate() 
        if(index){
            var h = ' '+(date.getHours() < 10 ? '0'+date.getHours() : date.getHours()) + ':'
            var m = (date.getMinutes() < 10 ? '0'+date.getMinutes() : date.getMinutes()) + ':'
            var s = date.getSeconds() < 10 ? '0'+date.getSeconds() : date.getSeconds()
            return Y+M+D+h+m+s
        }else{
            return Y+M+D
        }
    }else{
        return '--'
    }
}

//小数点
export const numFilter = (value,index) => {
    // 截取当前数据到小数点后三位
    let i = parseInt(index)
    let tempVal = parseFloat(value).toFixed(i)
    let realVal = tempVal.substring(0,  tempVal.length - 1)
    return realVal
}

//银行卡号
export  const BankCard = (value) =>{
    if(value){
        return value.replace(/(\w{6})\w*(\w{4})/, '$1********$2')
    }else{
        return '--'
    }  
}

//QQ号码
export  const QQNumber = (value) =>{
    if(value){
        return value.replace(/(\w{2})\w*(\w{2})/, '$1****$2')
    }else{
        return
    }  
}

//邮箱
export  const Emails = (value) =>{
    if(value){
        return value.replace(/(\w{6})/, '******')
    }else{
        return
    }  
}

//户籍地址
export  const HujiAddRess = (value) =>{
    if(!value){
        return       
    }else if(value.length <= 6){
        if(typeof value == 'string'){
            let ruten = value.substring(4);
            return value.replace(ruten,'************');
        } 
    }else{
        if(typeof value == 'string'){
            let ruten = value.substring(5);
            return value.replace(ruten,'************');
        }
    }
}

//居住地址
export  const AddRess = (value) =>{
    if(!value){
        return
    }else if(typeof value == 'string'){
        let ruten = value.substring(6);
        return value.replace(ruten,'************');
    } 
}

//姓名提取
export  const CaseName = (value) =>{
    if(typeof value == 'string'){
        let ruten = value.substring(1);
        return value.replace(ruten,'**');
    }
}

//性别提取
export const distillSex = (value) => {   
    let res = '';
    let len = 0;
    if (value != '' && value != undefined) {
        len = value.length;
        if (len == 15) {
            res = value.substring(14,15)
        } else {
            res = value.substring(16,17)
        }
    }           
    return res % 2 == 0 ? '女' : '男';
}

//提取身份证年龄
export const  extractAge = (idcard) => {
    if (!idcard) {
        return '--'
    }
    if(checkDate(idcard.substring(6,14))) {
        var myDate = new Date();
        var month = myDate.getMonth() + 1;
        var day = myDate.getDate();
        var age = myDate.getFullYear() - idcard.substring(6, 10) - 1;
        if (idcard.substring(10, 12) < month || idcard.substring(10, 12) == month && idcard.substring(12, 14) <= day) {
            age++;
        }
        return age;
    }
    return '--'
}
// var checkProv = function (val) {  //省份检测
//     var pattern = /^[1-9][0-9]/;
//     var provs = {11:"北京",12:"天津",13:"河北",14:"山西",15:"内蒙古",21:"辽宁",22:"吉林",23:"黑龙江 ",31:"上海",32:"江苏",33:"浙江",34:"安徽",35:"福建",36:"江西",37:"山东",41:"河南",42:"湖北 ",43:"湖南",44:"广东",45:"广西",46:"海南",50:"重庆",51:"四川",52:"贵州",53:"云南",54:"西藏 ",61:"陕西",62:"甘肃",63:"青海",64:"宁夏",65:"新疆",71:"台湾",81:"香港",82:"澳门"};
//     if(pattern.test(val)) {
//         if(provs[val]) {
//             return true;
//         }
//     }
//     console.log('不存在的省份！')
//     return false;
// }
// var checkCode = function (val) {  //校验码校验
//     var p = /^[1-9]\d{5}(18|19|20)\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/;
//     var factor = [ 7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2 ];
//     var parity = [ 1, 0, 'X', 9, 8, 7, 6, 5, 4, 3, 2 ];
//     var code = val.substring(17);
//     if(p.test(val)) {
//         var sum = 0;
//         for(var i=0;i<17;i++) {
//             sum += val[i]*factor[i];
//         }
//         if(parity[sum % 11] == code.toUpperCase()) {
//             return true;
//         }
//     }
//     console.log('校验码错误！')
//     return false;
// }
var checkDate = function (val) {  //出生日期码校验
    var pattern = /^(18|19|20)\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)$/;
    if(pattern.test(val)) {
        var year = val.substring(0, 4);
        var month = val.substring(4, 6);
        var date = val.substring(6, 8);
        var date2 = new Date(year+"-"+month+"-"+date);
        if(date2 && date2.getMonth() == (parseInt(month) - 1)) {
            return true;
        }
    }
    return false;
}

//委托方转中文
export  const EntrustsNo = (value) =>{
    let Entrusts = JSON.parse(sessionStorage.getItem('entrustsAll'));
    for (var key in Entrusts) {
        if (value == Entrusts[key]['id']) {
            return Entrusts[key]['name'];
        }
    }
}

//金额万位制
export const Money = (value) =>{
    if(value){
        return (value / 10000).toFixed(2)
    }else{
        return 0
    }
}

//金额每隔三位加逗号
export const toThousands = (num) =>{
    var result = '', counter = 0;
    var dot = String(num).indexOf(".");
    if(dot != -1){  //有小数点
        // 获取小数点后面的数字(indexOf和substring都不支持数字，所以要先转字符串才可以用)
        var dotCnt = String(num).substring(dot+1,num.length);
        // 获取小数点前面的数字
        num = String(num).split('.')[0]
        num = (num || 0).toString();
        for (var i = num.length - 1; i >= 0; i--) {
            counter++;
            result = num.charAt(i) + result;
            if (!(counter % 3) && i != 0) { result = ',' + result; }
        }
        result = result + '.' + dotCnt;
    }else{  //没有小数点
        result = (num || 0).toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,');
    }
    result = result.replace(/^\-\,/g,'-'); //负数
    return result

}


// WEBPACK FOOTER //
// ./src/api/filter.js